import React from "react";
import { connect } from "react-redux";
import XesEventHanlder from "./xes-event-handler";
import bindAll from 'lodash.bindall';
import mblock from '../mblock-sdk'
import hook from './hooks'

import {
    getXesEnvHanlder,
    isProjectTemplate,
} from "./xes.js";
import { postAssets } from "./xes-lib";
import {
    XesLoadingState,
    setXesProjectMeta,  
} from "../../reducers/project-state";
// 提供modal对project保存等操作
const XesSaverHoc = (WrappedComponent) => {
  class XesModalComponent extends React.Component {
    constructor(props) {
      super(props)
      this.xesEnvHandler = new XesEventHanlder(getXesEnvHanlder())
      bindAll(this, [
        'saveProject',
        'initListerner',
        'saveConfigureProject'
      ])
      this.initListerner()
    }
    saveProject() {
      let {
          xesProjectMeta,
          projectWasLoaded
      } = this.props

      if (!projectWasLoaded) {
        return
      }
      let id = null,
          original_id = null
      if(isProjectTemplate(xesProjectMeta.category) && !xesProjectMeta._adapt){
       id = null
       original_id = xesProjectMeta.id
      }else{
        id = xesProjectMeta.id
        original_id = xesProjectMeta.original_id
      }
      let params = Object.assign({}, {
          id,
          original_id,
          version: 'hw1.0',
          name: this.props.projectTitle,
          xml: mblock.getCode(),
          thumbnail: mblock.getCover() // this.props.renderer.canvas.toDataURL("image/png",1.0)
      })
      return postAssets(mblock.getAssets()).then(() => {
        return this.xesEnvHandler.handle(XesLoadingState.XES_SAVING, params).then((data) => {
            return Promise.resolve(data)
        })
      })
    }
    saveConfigureProject(additionalParams, isNew) {
      // debug
      let {
        xesProjectMeta,
        projectWasLoaded
      } = this.props

      if (!projectWasLoaded) {
        return
      }
      let id = null,
          original_id = null
      if(isProjectTemplate(xesProjectMeta.category) && !xesProjectMeta._adapt){
        id = null
        original_id = xesProjectMeta.id
      }else{
        id = xesProjectMeta.id
        original_id = xesProjectMeta.original_id
      }
      let params = Object.assign({}, {
          id,
          original_id,
          version: 'hw1.0',
          name: this.props.projectTitle,
          xml: mblock.getCode(),
          thumbnail: mblock.getCover(), // this.props.renderer.canvas.toDataURL("image/png",1.0)
          ...additionalParams
      })

      const saveType = isNew ? XesLoadingState.XES_SAVING_AS : XesLoadingState.XES_SAVING
      console.log(
        'mblock.getAssets()',
        mblock.getAssets()
      )

      return postAssets(mblock.getAssets()).then(() => {
        
        return window.exportScratch(params)
        // return this.xesEnvHandler.handle(saveType, params).then((data) => {
        //     return Promise.resolve(data)
        // })
      }).catch(err => {
        alert("保存作品失败")
        return new Promise((resolve, reject) => {
            return resolve();
        });
      })
    }
    initListerner() {
      hook.addHook(hook.types.AFTER_SAVE, (data) => {
        this.props.setXesProjectMeta(data)
      })
    }
    render() {
      return (
        <WrappedComponent saveProject={this.saveProject} saveConfigureProject={this.saveConfigureProject} />
      )
    }
  }
  const mapStateToProps = (state) => {
      return {
          xesProjectMeta: state.scratchGui.xesProjectState.xesProjectMeta,
          projectTitle: state.scratchGui.projectTitle,
          projectWasLoaded: state.scratchGui.xesProjectState.isLoaded
      }
  }
  const mapDispatchToProps = (dispatch) => ({
      setXesProjectMeta: projectMeta => dispatch(setXesProjectMeta(projectMeta)),
  })
  return connect(
      mapStateToProps,
      mapDispatchToProps
  )(XesModalComponent)
}

export default XesSaverHoc